import { Injectable } from '@angular/core';
import { DetailNavigasi } from '../../../models/master-user/detail-navigasi.model';
import { Adapter } from '../adapter.service';

@Injectable({
  providedIn: 'root',
})
export class DetailNavigasiAdapter implements Adapter<DetailNavigasi> {
  public adapt(item: any): DetailNavigasi {
    return {
      id: item.idDetailNav,
      referenceNavigasi: {
        id: item.idReferenceNavigation,
        nama: item.nama,
        url: item.urlSuperApp,
        module: item.modulSuperApp,
        newTab: Number(item.newTab) === 1,
        urutan: item.urutan,
        navigasi: {
          id: item.idNavigation,
          nama: item.namaHeader,
          iconSuperApp: item.iconSuperApp,
          urutan: item.urutanNavigasi,
          group: item.groupNavigasi,
          urutanGroup: item.urutanGroup,
        },
        tipeKlinik: item.typeKlinik,
      },
      view: item.view,
      add: item.add,
      del: item.del,
      edit: item.edit,
    };
  }
}
